import { createContext, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { INVOICE_PLAN_SYSCODE, InvoicePlanSyscodeString } from "../../../constants/invoice_plan_syscode.jsx";

export const developerCertificationTabContext = createContext();
export const developerCertificationCurrentTabContext = createContext();

export const CertificationContextProvider = ({ environment, children }) => {
  const location = useLocation();
  const allTabs = useMemo(() => {
    if (environment === InvoicePlanSyscodeString[INVOICE_PLAN_SYSCODE.Sandbox]) {
      return [
        { name: "NETS QR (Web)", value: 0 },
        { name: "NETS QR (Mobile)", value: 1 },
        { name: "eNETS (Web)", value: 2 },
      ];
    }
    return [
      { name: "NETS Click", value: 0 },
      { name: "NETS QR (Web)", value: 1 },
      { name: "NETS QR (Mobile)", value: 2 },
      { name: "eNETS (Web)", value: 3 },
      { name: "eNETS (Mobile)", value: 4 },
    ];
  }, [environment]);

  const filteredTabs = useMemo(() => {
    const tabValue = location.state?.tabValue;
    if (tabValue !== undefined) {
      const match = allTabs.find((t) => t.value === tabValue);
      return match ? [match] : allTabs;
    }
    return allTabs;
  }, [allTabs, location.state]);

  const [currentTab, setTab] = useState(filteredTabs[0]);

  // const [currentTab, setTab] = useState(tabs[0]);

  // const setTabByValue = (value) => {
  //   const matchingTab = tabs.find((tab) => tab.value === value);
  //   if (matchingTab) {
  //     setTab(matchingTab);
  //   }
  // };

  const setTabByValue = (value) => {
    const matchingTab = filteredTabs.find((tab) => tab.value === value);
    if (matchingTab) {
      setTab(matchingTab);
    }
  };

  const contextValue = { currentTab, setTab, setTabByValue };

  return (
    <developerCertificationTabContext.Provider value={{ tabs: filteredTabs }}>
      <developerCertificationCurrentTabContext.Provider value={contextValue}>
        {children}
      </developerCertificationCurrentTabContext.Provider>
    </developerCertificationTabContext.Provider>
  );
};
